(function() {
    'use strict';

    angular
        .module('liverunApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('medal-board', {
            parent: 'entity',
            url: '/medal-board',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.medalBoard.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/medal-board/medal-boards.html',
                    controller: 'MedalBoardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('medalBoard');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('medal-board-detail', {
            parent: 'medal-board',
            url: '/medal-board/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.medalBoard.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/medal-board/medal-board-detail.html',
                    controller: 'MedalBoardDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('medalBoard');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MedalBoard', function($stateParams, MedalBoard) {
                    return MedalBoard.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'medal-board',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('medal-board-detail.edit', {
            parent: 'medal-board-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/medal-board/medal-board-dialog.html',
                    controller: 'MedalBoardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MedalBoard', function(MedalBoard) {
                            return MedalBoard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('medal-board.new', {
            parent: 'medal-board',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/medal-board/medal-board-dialog.html',
                    controller: 'MedalBoardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                createdDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('medal-board', null, { reload: 'medal-board' });
                }, function() {
                    $state.go('medal-board');
                });
            }]
        })
        .state('medal-board.edit', {
            parent: 'medal-board',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/medal-board/medal-board-dialog.html',
                    controller: 'MedalBoardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MedalBoard', function(MedalBoard) {
                            return MedalBoard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('medal-board', null, { reload: 'medal-board' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('medal-board.delete', {
            parent: 'medal-board',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/medal-board/medal-board-delete-dialog.html',
                    controller: 'MedalBoardDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MedalBoard', function(MedalBoard) {
                            return MedalBoard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('medal-board', null, { reload: 'medal-board' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
